import { DeepEagerLoaded } from "../../types/base/orm";
import { Category } from "../../types/category";
import { TaxQuestionAnswerBase } from "../../types/taxQuestionAnswer";
import { Transaction, TransactionBase } from "../../types/transaction";
import { CounterpartyDto } from "../counterparty/counterparty.dto";
import { EntityDto, EntityWithUserDto } from "../entity/entity.dto";
import { FinancialAccountDto } from "../financialAccount/financial-account.dto";
import { TransactionMatchDto } from "../transactionMatch/transaction-match.dto";
import { TransactionBaseDto } from "./transaction-base.dto";

/**
 * Input type for TransactionDto constructor.
 * Accepts transaction with required relations loaded.
 */
export type TransactionDtoInput = DeepEagerLoaded<
    TransactionBase,
    {
        financialAccount: { entity: { user: true } };
        entity: { user: true };
    }
>;

export class TransactionDto extends TransactionBaseDto {
    financialAccount: FinancialAccountDto;
    entity: EntityWithUserDto;
    taxQuestionAnswers: Array<TaxQuestionAnswerBase<TransactionBase>>;
    transactionMatches?: TransactionMatchDto[];
    counterparty?: CounterpartyDto;
    category?: Category;

    static deserialize(dto: TransactionDto): Transaction {
        const base = {
            ...dto,
            ...TransactionBaseDto.deserialize(dto),
            financialAccount: FinancialAccountDto.deserialize(
                dto.financialAccount,
            ),
            entity: EntityDto.deserialize(dto.entity),
            transactionMatches: dto.transactionMatches?.map(
                TransactionMatchDto.deserialize,
            ),
            counterparty: dto.counterparty
                ? CounterpartyDto.deserialize(dto.counterparty)
                : undefined,
        };
        // Cast taxQuestionAnswers to the specific generic type
        return base as Transaction;
    }

    constructor(transaction: TransactionDtoInput) {
        super(transaction);

        this.financialAccount = new FinancialAccountDto(
            transaction.financialAccount,
        );
        this.entity = new EntityWithUserDto(transaction.entity);
        this.taxQuestionAnswers = transaction.taxQuestionAnswers ?? [];
        this.transactionMatches = transaction.transactionMatches?.map(
            (tm) => new TransactionMatchDto(tm),
        );
        this.counterparty = transaction.counterparty
            ? new CounterpartyDto(transaction.counterparty)
            : undefined;
        this.category = transaction.category;
    }
}
